module.exports = __webpack_public_path__ + "static/partner-bg-052c60c71b9b20a8c1ac801b55d02692.png";